import React, { useState } from 'react';
import { Box, Typography, Grid, Button, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import Toaster from 'src/Toaster/Toaster';
import { url } from 'src/Helpers/utils/Constant';
import { useAuthContext } from 'src/components/Context/AuthContext/AuthContext';
import { HttpClient } from 'src/Helpers/http/http';
import { IResponse } from 'src/Types/module/common/commonTypes';

interface Props {
  memberId: string;
  setRefresh: (value: boolean) => void;
  setOpen: (value: boolean) => void;
  refresh: boolean;
}
const ParticularsOfPersonRepresentOrganization = ({
  memberId,
  setRefresh,
  setOpen,
  refresh,
}: Props) => {
  const { user } = useAuthContext();
  const { register, handleSubmit } = useForm();
  const [date, setDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (inputsData: any) => {
    setIsLoading(true);
    inputsData.company_trade_license_expiry_date = date;

    const formData = new FormData();
    Object.keys(inputsData).forEach((key) => {
      if (typeof inputsData[key] === 'object') {
        formData.append(key, inputsData[key][0]);
      } else {
        formData.append(key, inputsData[key]);
      }
    });

    try {
      const data: IResponse = await HttpClient.post(
        `/api/atab/admin/member-company/member/license/${memberId}`,
        formData
      );

      if (data.success) {
        Toaster().fire({
          icon: 'success',
          title: data.message,
        });
        setRefresh(!refresh);
        setIsLoading(false);
        setOpen(false);
      }
    } catch (err: any) {
      Toaster().fire({
        icon: 'error',
        title: err?.response?.data.message,
      });
      setIsLoading(false);
    }
  };
  return (
    <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box>
              <label htmlFor=''>
                Trade license number <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                label='Enter trade license number '
                type='text'
                required
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_trade_license')}
              />
            </Box>
            <Box>
              <label htmlFor=''>
                TIN number <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                label='Enter tin number'
                type='number'
                required
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_tin_number')}
              />
            </Box>
            <Box>
              <label htmlFor=''>Upload BIN File / document </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                type='file'
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_bin_file')}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <label htmlFor=''>
                Trade license expiry date{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                id='date'
                type='date'
                required
                onChange={(e) => setDate(e.target.value)}
                sx={{ width: '100%', pb: 2 }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box>
              <label htmlFor=''>
                Proof of Submission of Tax Return (Acknowledgement Receipt){' '}
                <span style={{ color: 'red' }}>*</span>{' '}
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                type='file'
                required
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_tin_file')}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <label htmlFor=''>
                Upload trade license File / document{' '}
                <span style={{ color: 'red' }}>*</span>
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                type='file'
                required
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_trade_license_file')}
              />
            </Box>
            <Box>
              <label htmlFor=''>
                Bin number (Business Identification Number)
              </label>
              <TextField
                id='outlined-basic'
                variant='outlined'
                label='Enter bin number'
                type='text'
                fullWidth
                sx={{ pb: 2 }}
                {...register('company_bin_number')}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ pt: 5, textAlign: 'end', mb: 2 }}>
        {isLoading ? (
          <Button
            disabled
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            loading..
          </Button>
        ) : (
          <Button
            type='submit'
            variant='contained'
            disableElevation
            className='add-remove-button'
          >
            Submit
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ParticularsOfPersonRepresentOrganization;
